import React, { useState } from "react";
import { Upload, Button, message, Image } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";

const MAX_BYTES = 2 * 1024 * 1024; // 2 MB
const ALLOWED = ["image/jpeg", "image/png", "image/webp", "image/gif"];

/**
 * Dropzone + preview de icono del juego. NO sube nada por si mismo:
 * notifica al padre via onChange(file | null) y el padre decide
 * cuando hacer upload (en wizard tras crear, o en edit modal al
 * pulsar Save).
 *
 * Props:
 *   - value: { url?: string, file?: File } | null
 *   - onChange(value)
 *   - disabled: bool
 */
export function IconUploader({ value, onChange, disabled }) {
  const [previewUrl, setPreviewUrl] = useState(
    value && value.url ? value.url : null,
  );

  const beforeUpload = (file) => {
    if (!ALLOWED.includes(file.type)) {
      message.error("Solo jpg, png, webp o gif.");
      return Upload.LIST_IGNORE;
    }
    if (file.size > MAX_BYTES) {
      message.error("Imagen demasiado grande (max 2 MB).");
      return Upload.LIST_IGNORE;
    }
    const reader = new FileReader();
    reader.onload = (e) => setPreviewUrl(e.target.result);
    reader.readAsDataURL(file);
    onChange({ file });
    return false; // prevent auto-upload
  };

  const clear = () => {
    setPreviewUrl(null);
    onChange(null);
  };

  return (
    <div>
      {previewUrl ? (
        <div
          style={{
            display: "flex",
            gap: 12,
            alignItems: "center",
            marginBottom: 8,
          }}
        >
          <Image
            src={previewUrl}
            width={96}
            height={96}
            style={{ objectFit: "cover", borderRadius: 8 }}
            preview={false}
          />
          {!disabled && (
            <Button
              icon={<DeleteOutlined />}
              danger
              onClick={clear}
              size="small"
            >
              Quitar
            </Button>
          )}
        </div>
      ) : (
        <Upload
          beforeUpload={beforeUpload}
          showUploadList={false}
          accept="image/jpeg,image/png,image/webp,image/gif"
          disabled={disabled}
        >
          <Button icon={<UploadOutlined />} disabled={disabled}>
            Seleccionar imagen (max 2 MB)
          </Button>
        </Upload>
      )}
    </div>
  );
}
